var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message)?_c('transition',{attrs:{"name":"fade"}},[(_vm.visible)?_c('div',{staticClass:"toast"},[_vm._v(_vm._s(_vm.message))]):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }